module.exports = __webpack_public_path__ + "img/petlifecycle.3c186bf9.png";